import React from "react";
import trashCan from "../images/icon-delete.svg";

const CartItem = ({ image, title, number, price, index, deleteItem }) => {
    return (
        <div className="flex items-center justify-between p-6 w-full">
            <div className="flex items-center gap-4">
                <img
                    src={image}
                    alt={title}
                    className="max-w-[50px] max-h-[50px] rounded-[4px]"
                />
                <div>
                    <p className="cartItem">{title}</p>
                    <p className="cartItem">
                        ${price.toFixed(2)} x {number}{" "}
                        <span className="font-bold text-black">
                            ${(number * price).toFixed(2)}
                        </span>
                    </p>
                </div>
            </div>
            <img
                src={trashCan}
                alt="delete"
                className="hover:cursor-pointer"
                onClick={() => deleteItem(index)}
            />
        </div>
    );
};

export default CartItem;
